<template>
  <v-card outlined :style="cssVars" :class="cardStatus" @click="clicado" style="font-size:12px;">
    <div style="display:flex;align-items:center;padding:2px 4px">
      <div style="flex:2;text-align:right;">
        <v-icon :size="size" class="cardIcon mx-1" :style="cssVars">
          {{ icon }}
        </v-icon>
      </div>
      <div style="flex:8;text-align:center;font-size:11px;">{{ subtitle }}</div>
      <div style="flex:2;text-align:center;">
        <v-chip small label :color="col" dark>
          {{ title }}
        </v-chip>
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'DashboardCardButton',
  props: ['title', 'subtitle', 'icon', 'color', 'click', 'size', 'ativo'],
  data: () => ({
    cardStatus: 'card clicado',
    status: false,
    col: '',
  }),
  computed: {
    cssVars() {
      return { '--border-color': this.color, '--icon-color': this.color }
    },
  },
  methods: {
    clicado() {
      if (this.status === true) {
        this.status = false
      } else {
        this.status = true
      }
      this.draw()
      this.$emit('click')
    },
    draw() {
      if (this.status === true) {
        this.cardStatus = 'pa-0 card clicado'
        this.col = this.color
      } else {
        this.cardStatus = 'pa-0  card'
        this.col = '#dedede'
      }
    },
  },
  mounted() {
    this.status = this.ativo
    this.draw()
  },
}
</script>

<style scoped>
.card {
  background: #ffffff !important;
  margin: auto;
}
.cardIcon {
  color: #dedede;
}
.v-avatar {
  background: #dedede;
}
.clicado {
  border: 1px solid var(--border-color) !important;
}

.clicado .cardIcon {
  color: var(--icon-color) !important;
}

.clicado .v-avatar {
  background: var(--icon-color) !important;
}
</style>
